import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import BaseModal, { modalStyles, HoverButton } from './BaseModal';
import { colors, typography } from '../../styles/theme';
import ModalStickyFooter from '../ui/ModalStickyFooter';
import { FontAwesome6 } from '@expo/vector-icons';

interface UnlockedModalProps {
  visible: boolean;
  onClose: () => void;
  packName?: string;
  isPicloPlay?: boolean;
}

export default function UnlockedModal({ visible, onClose, packName, isPicloPlay }: UnlockedModalProps) {
  const displayPackName = packName ? (packName.toLowerCase().includes('pack') ? packName : `${packName} Pack`) : 'Pack';
  const title = isPicloPlay ? "Piclo Play Unlocked" : `${displayPackName} Unlocked`;
  const message = isPicloPlay
    ? "Thank you for purchasing Piclo Play! You now have full access to all premium puzzle packs, as well as the custom puzzle generator."
    : `Thank you for purchasing the ${displayPackName}! You now have full access to all puzzles in the pack.`;

  return (
    <BaseModal
      visible={visible}
      onClose={onClose}
      isFullScreenOnMobile={false}
      header={<Text style={modalStyles.headerText}>{title}</Text>}
      footer={(
        <ModalStickyFooter>
          <HoverButton
            style={modalStyles.primaryButton}
            hoverStyle={modalStyles.primaryButtonHover}
            textStyle={modalStyles.primaryButtonText}
            onPress={onClose}
          >
            Continue
          </HoverButton>
        </ModalStickyFooter>
      )}
    >
      <View style={styles.container}>
        <View style={styles.iconContainer}>
          <FontAwesome6 name="check" size={48} color={colors.success} solid />
        </View>

        <Text style={styles.paragraph}>
          {message}
        </Text>
      </View>
    </BaseModal>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    marginBottom: 20
  },
  iconContainer: {
    marginVertical: 24,
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: `${colors.success}20`,
    justifyContent: 'center',
    alignItems: 'center',
  },
  paragraph: {
    ...typography.body,
    color: colors.text,
    fontSize: 18,
    marginBottom: 16,
    lineHeight: 26,
    textAlign: 'center'
  },
});
